import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from './components/Main'
import AddProject from './components/AddProject';
import TechDirectory from './components/tech_directory/TechDirectory';
import supabase from "./supabaseClient";
import 'mapbox-gl/dist/mapbox-gl.css';
import ApproveProjects from './components/ApproveProjects';
import AddProvider from './components/tech_directory/AddProvider';
import ApproveProviders from './components/tech_directory/ApproveProviders';
import ConferenceCountries from './components/conference_countries/ConferenceCountries';

function App() {
  return (
  <BrowserRouter>
    <Routes>
    <Route path="/" element={<Main db={supabase} />}/>
    <Route path="/addproject" element={<AddProject db={supabase} />}/>
    <Route path="/approveprojects" element={<ApproveProjects db={supabase} />}/>
    <Route path="/techdirectory" element={<TechDirectory db={supabase} />}/>
    <Route path="/addprovider" element={<AddProvider db={supabase} />}/>
    <Route path="/approveproviders" element={<ApproveProviders db={supabase} />}/>
    <Route path="/conference-countries" element={<ConferenceCountries />}/>
    </Routes>
  </BrowserRouter>
  );
}

export default App;
